import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 实时监测环境监测的实时数据接口
    GetFuZhuJianKong({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('api/equipment/v1/GetFuZhuJianKong', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}
export default StationManageService
